import api from './client';

export const listNotifications = async ({ limit = 30, unreadOnly = false } = {}) => {
  const res = await api.get('/notifications', { params: { limit, unread_only: unreadOnly } });
  return res.data;
};

export const notificationsUnreadCount = async () => {
  const res = await api.get('/notifications/unread-count');
  return res.data;
};

export const markNotificationsRead = async (ids = null) => {
  const res = await api.post('/notifications/mark-read', { ids });
  return res.data;
};

export const deleteNotification = async (id) =>
  (await api.delete(`/notifications/${encodeURIComponent(id)}`)).data;

export const deleteAllNotifications = async () =>
  (await api.delete('/notifications')).data;
